module.exports = __webpack_public_path__ + "static/media/default@3x.dadcaa8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/flags/default@3x.png
// module id = 498
// module chunks = 0